import { render, staticRenderFns } from "./CommonContainer.vue?vue&type=template&id=716e7e98&scoped=true"
import script from "./CommonContainer.vue?vue&type=script&lang=js"
export * from "./CommonContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonContainer.vue?vue&type=style&index=0&id=716e7e98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e7e98",
  null
  
)

export default component.exports